import type { BriefingStepLike } from './types'

export type RequiredBriefingStepsSummary = {
  completeCount: number
  totalCount: number
  isComplete: boolean
}

export function summarizeRequiredBriefingSteps(
  steps: readonly BriefingStepLike[]
): RequiredBriefingStepsSummary {
  const requiredSteps = steps.filter((step) => step.requiredness === 'required')
  const completeCount = requiredSteps.filter(
    (step) => step.status === 'done'
  ).length
  const totalCount = requiredSteps.length

  return {
    completeCount,
    totalCount,
    isComplete: totalCount > 0 && completeCount === totalCount,
  }
}
